import React, { useState, useEffect } from 'react'
import { graphql, } from 'gatsby'
import { getMainCollection } from '../../utils/api/gql-queries';

import SEO from '~/components/seo'
import ProductGrid from '~/components/ProductGrid'

import { Container } from '~/styles/global'

const CategoryPage = ({
  data: {
    collection,
    pageData: {
      frontmatter: { seo_title, seo_description },
    },
  },
}) => {
  const [products, setProducts] = useState(collection.products)


  const updateProducts = (data) => {
    // Get current state
    const existingProducts = products;
    const updatedProducts = [];
    const newProductData = data;

    // Update existing products with newly fetched Shopify data (might contain updates)
    for (let i = 0; i < newProductData.length; i++) {
      const currentNewProduct = newProductData[i].node;

      for (let j = 0; j < existingProducts.length; j++) {
        const existingProduct = existingProducts[j];
        if (currentNewProduct.handle === existingProduct.handle) {
          const updatedProduct = {
            ...existingProduct, ...currentNewProduct
          }
          updatedProducts.push(updatedProduct);
          break;
        }

      }
    }
    setProducts(updatedProducts);
    // console.log('products are', data.data.collectionByHandle.products.edges)
  }



  useEffect(() => {
    getMainCollection()
    .then(products => updateProducts(products))
    .catch(err => console.error('Something went wrong getting products'));
  }, [])

  return (
    <>
      <div />
      <SEO title={seo_title} descriptions={seo_description} />
      <Container>
        {/* <GridWrapper>
          <CategoryMenu categories={categories.edges} /> */}
        <ProductGrid products={products} />
        {/* </GridWrapper> */}
      </Container>
    </>
  )
}

export const query = graphql`
  query($slug: String) {
    collection: shopifyCollection(handle: {eq: "all"}) {
      products {
        id
        title
        availableForSale
        description
        handle
        images {
          originalSrc
          id
          localFile {
            childImageSharp {
              fluid(maxHeight: 800) {
                ...GatsbyImageSharpFluid
              }
              fixed(height: 900) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
        variants {
          price
          title
        }  
      }
    }
    categories: allShopifyCollection {
      edges {
        node {
          title
          handle
          id
        }
      }
    }
    pageData: markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        seo_title
        seo_description
      }
    }
  }
`

export default CategoryPage
